import MUISkeleton from '@mui/material/Skeleton';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const Skeleton = ({ isLoading = false, children, ...props }) => {
  const isText =
    props.variant === null ||
    props.variant === undefined ||
    props.variant === 'text';

  return !isLoading ? (
    children
  ) : (
    <MUISkeleton
      sx={{
        ...(isText && {
          transform: 'scale(1, 0.9)',
        }),
      }}
      {...props}
    >
      {!isText && children}
    </MUISkeleton>
  );
};

export default Skeleton;

export const TableSkeleton = ({ columns, rows }) => {
  return (
    <TableBody>
      {Array.from({ length: rows }, (_, indexRow) => {
        return (
          <TableRow key={indexRow}>
            {Array.from({ length: columns }, (_, indexColumn) => {
              return (
                <TableCell key={`${indexRow}-${indexColumn}`}>
                  <Skeleton isLoading />
                </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </TableBody>
  );
};
